<script>
  import { LmsUtils } from '../../../../../LMS/utils/LmsUtils';
  import { External } from '../../../../../external';

  export let activityType, data = { circleId: '', circleName: '', groupId: '', groupName: '' },
    contact;

  let clickHandler = async () => {
    let circles = await LmsUtils.listCircles();
    let circle = circles.find(circle => circle.id === data.circleId);
    if (circle) {
      External.CPanel.goToUrl(`/me/community/circles/${circle.url}`);
    }
  };
</script>

<a class="blue-text" on:click={clickHandler}>
  {#if data.groupName}
    {data.circleName} → {data.groupName}
  {:else}
    {data.circleName}
  {/if}
</a>
